const compareDatumWithLimit = ({ datum, operator, limitValue }: { datum: number; operator: string; limitValue: number }) => {
    if (isNaN(datum) || typeof datum !== 'number' || typeof operator !== 'string' || isNaN(limitValue) || typeof limitValue !== 'number') {
        console.warn('missing/invalid args to do comparison', datum, operator, limitValue);
        return false;
    }

    switch (operator) {
        case 'equal':
        case 'is exactly equal to':
            return datum == limitValue;
        case 'notEqual':
        case 'is not equal to':
            return datum != limitValue;
        case 'lessThan':
        case 'is less than':
            return datum < limitValue;
        case 'lessThanOrEqual':
        case 'is less than or equal to':
            return datum <= limitValue;
        case 'greaterThan':
        case 'is greater than':
            return datum > limitValue;
        case 'greaterThanOrEqual':
        case 'is greater than or equal to':
            return datum >= limitValue;
        default:
            return false;
    }
};

export default compareDatumWithLimit;
